import { Select, Radio, Button, Space } from "antd";

const ConfigFilterDropdown = ({
  setSelectedKeys,
  selectedKeys,
  confirm,
  clearFilters,
  channels = [],
  showDeliveryMethods = false,
}) => {
  const valStr = selectedKeys[0];
  const currentOption = valStr ? valStr.substring(0, valStr.lastIndexOf(":")) : undefined; // e.g., "method:take_out" or "channel:kiosko"
  const currentStatus = valStr ? valStr.substring(valStr.lastIndexOf(":") + 1) : "active";

  return (
    <div style={{ padding: 12, width: 230 }}>
      <div style={{ marginBottom: 8 }}>
        <strong>Filtrar por configuración</strong>
      </div>
      <div style={{ marginBottom: 12 }}>
        <Select
          style={{ width: "100%" }}
          placeholder="Seleccionar opción"
          value={currentOption}
          onChange={(val) => {
            if (val) {
              setSelectedKeys([`${val}:${currentStatus}`]);
            } else {
              setSelectedKeys([]);
            }
          }}
          allowClear
        >
          {showDeliveryMethods && (
            <Select.OptGroup label="Métodos de Entrega">
              <Select.Option value="method:take_out">Llevar</Select.Option>
              <Select.Option value="method:delivery">Domicilio</Select.Option>
              <Select.Option value="method:eat_in">Sala</Select.Option>
            </Select.OptGroup>
          )}
          {channels.length > 0 && (
            <Select.OptGroup label="Canales de Venta">
              {channels.map((chan) => (
                <Select.Option key={chan} value={`channel:${chan.toLowerCase()}`}>
                  {chan.toUpperCase()}
                </Select.Option>
              ))}
            </Select.OptGroup>
          )}
        </Select>
      </div>
      <div style={{ marginBottom: 12 }}>
        <Radio.Group
          disabled={!currentOption}
          value={currentStatus}
          onChange={(e) => {
            if (currentOption) {
              setSelectedKeys([`${currentOption}:${e.target.value}`]);
            }
          }}
        >
          <Radio value="active">Activo</Radio>
          <Radio value="inactive">Inactivo</Radio>
        </Radio.Group>
      </div>
      <Space style={{ display: "flex", justifyContent: "space-between" }}>
        <Button
          size="small"
          onClick={() => {
            clearFilters();
            confirm();
          }}
        >
          Reiniciar
        </Button>
        <Button
          type="primary"
          size="small"
          onClick={() => confirm()}
        >
          Aceptar
        </Button>
      </Space>
    </div>
  );
};

export default ConfigFilterDropdown;
